import React from 'react'

function Footer() {
  return (
    <div>
        <div id='footer'>
        <p><i className="fa-regular fa-copyright"></i> LexiTrove Labs 2026 · Built with Employment Practitioners.</p>
        <a href='https://www.linkedin.com/company/lexitrove-labs/' target='_blank' rel="noreferrer"><i class="fa-brands fa-linkedin"></i></a>
        </div>
    </div>
  )
}

export default Footer